import property1 from "./assets/IMG-20250222-WA0032.jpg";
import Farm from "./assets/IMG-20250222-WA0046.jpg";
import villa2 from "./assets/IMG-20250222-WA0045.jpg";
import office1 from "./assets/office1.jpg";
import room1 from "./assets/IMG-20250222-WA0045.jpg";
import room2 from "./assets/IMG-20250222-WA0044.jpg";
import room3 from "./assets/IMG-20250222-WA0029.jpg";
import room4 from "./assets/IMG-20250222-WA0031.jpg";

export const filterOptions = [
  {
    id: 1,
    title: "property type",
    options: ["residential", "commercial", "land", "industrial"],
  },
  {
    id: 2,
    title: "price limit",
    options: [
      "$1000",
      "$50,000",
      "$100,000",
      "$250,000",
      "$500,000",
      "$500,000+",
    ],
  },
  {
    id: 3,
    title: "Bedrooms",
    options: ["1 Bedroom", "2 Bedrooms", "3 Bedrooms", "3 Bedrooms+"],
  },
  {
    id: 4,
    title: "Bathrooms",
    options: ["1 Bathroom", "2 Bathrooms", "3 Bathrooms", "3 Bathrooms+"],
  },
  {
    id: 5,
    title: "Area Size (sqm)",
    options: ["100 (sqm)", "150 (sqm)", "175 (sqm)", "200 (sqm)", "200+ (sqm)"],
  },
];

export const properties = [
  {
    id: 1,
    title: "إيجار",
    image: property1,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "apartment",
    price: "",
    bedrooms: "",
    bathrooms: "",
    size: "",
  },
  {
    id: 2,
    title: "أُوكَازيُون",
    image: Farm,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "Farm",
    price: "",
    bedrooms: '',
    bathrooms: "",
    size: 796152,
  },
  {
    id: 3,
    title: "إيجار",
    image: villa2,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "",
    bedrooms: "",
    bathrooms: "",
    size: "",
  },
  {
    id: 4,
    title: "إيجار",
    image: office1,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "office",
    price: "",
    bedrooms: "",
    bathrooms: "",
    size: "",
  },
  
];

export const propertyImages = [
  {
    id: 1,
    image: room1,
  },
  {
    id: 2,
    image: room2,
  },
  {
    id: 3,
    image: room3,
  },
  {
    id: 4,
    image: room4,
  },
 /* {
    id: 5,
    image: farm1,
  },
  {
    id: 6,
    image: farm2,
  },
  {
    id: 7,
    image: farm3,
  },
  {
    id: 8,
    image: farm4,
  },*/
];

 


export const amenities = [
 
];
